import { createContext, useContext } from 'react';

export type Collection =
  | 'companies'
  | 'customers'
  | 'appointments'
  | 'users'
  | 'userGroups'
  | 'questionnaires'
  | 'services'
  | 'addOns'
  | 'venues';

export type Loader<TParams, TResult> = (params: TParams) => Promise<TResult>;

export interface CacheEntry<TResult = unknown> {
  promise: Promise<TResult>;
  status: 'pending' | 'fulfilled' | 'rejected';
  value?: TResult;
  error?: unknown;
  version: number;
}

export interface StaffDataContextValue {
  read: <TParams, TResult>(
    collection: Collection,
    params: TParams,
    loader: Loader<TParams, TResult>
  ) => TResult;
  invalidate: (collection: Collection) => void;
  subscribe: (collection: Collection, listener: () => void) => () => void;
}

export const StaffDataContext = createContext<StaffDataContextValue | null>(null);

export const useStaffDataContext = (): StaffDataContextValue => {
  const ctx = useContext(StaffDataContext);
  if (!ctx) {
    throw new Error(
      'StaffData hooks must be used inside <StaffDataProvider>. Mount it under AdminDashboard.'
    );
  }
  return ctx;
};
